import React, { Component, useState } from 'react';
import DonutSubmission from '../components/DonutSubmission';
import { useEffect } from 'react';
import BarRanking from '../components/BarRanking';
import TableEagleStatus from '../components/TableEagleStatus';
import { useTranslation } from 'react-i18next';

const Dashboard = () => {

    const [icNo, setIcNo] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [searchButtonPressed, setSearchButtonPressed] = useState(false);
    const { t } = useTranslation();



    const handleSearch = (event) => {
        event.preventDefault();
        setSearchButtonPressed(!searchButtonPressed);
    };

    useEffect(() => {
        document.title = "Improved Earnings";
    }, []);


    const search = <form onSubmit={handleSearch}>
        <div>
            <table className="tb-form txt-font" style={{ width: '100%' }}>
                <tr>
                    <td>{t('League.PhoneNo')}</td>
                    <td><input type="text" className="margB5px" required value={phoneNo} onChange={(e) => { const regex = new RegExp("^[0-9]{1,4}$"); if (!e.target.value || regex.test(e.target.value)) { setPhoneNo(e.target.value); } }} minLength="4" maxLength="4" placeholder="0000" /></td>
                </tr>
                <tr>
                    <td>{t('League.IcNo')}</td>
                    <td><input type="text" className="margB5px" required value={icNo} onChange={(e) => { const regex = new RegExp("^[0-9]{1,12}$"); if (!e.target.value || regex.test(e.target.value)) { setIcNo(e.target.value); } }} minLength="12" maxLength="12" placeholder="901206105442" /></td>
                </tr>

            </table>
            <div className="text-align-right txt-font text-padding-right-10px">
                <button type="submit" className="btn-search" ><i className="fa fa-search"></i></button>
            </div>
        </div>
    </form>

    return (
        <div>
            {/*<div>*/}
            {/*    {search}*/}
            {/*</div>*/}
            <div>
                <TableEagleStatus IcNo={icNo} phoneNo={phoneNo} searchButtonPressed={searchButtonPressed} />
            </div>
        </div>
    );

}

export default Dashboard;
